import React from 'react'

import SvgMultiElements from '../SvgMultiElements'
import pauseIcon from '../../../assets/icons/pause-icon'

export default () => <SvgMultiElements config={pauseIcon} />
